/* Little cartoon monkey face used as the site logo mark. */
export default function MonkeyMark({ size = 30 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
            {/* ears */}
            <circle cx="8.5" cy="22" r="7" fill="#a9703f" stroke="#5b3a1c" strokeWidth="2.5" />
            <circle cx="39.5" cy="22" r="7" fill="#a9703f" stroke="#5b3a1c" strokeWidth="2.5" />
            <circle cx="8.5" cy="22" r="3" fill="#f6dcb4" />
            <circle cx="39.5" cy="22" r="3" fill="#f6dcb4" />
            {/* head */}
            <circle cx="24" cy="23" r="15" fill="#a9703f" stroke="#5b3a1c" strokeWidth="2.5" />
            {/* fringe */}
            <path d="M10 17 C 14 8 34 8 38 17 C 32 13 16 13 10 17 Z" fill="#7d4f26" />
            {/* muzzle */}
            <ellipse cx="24" cy="30" rx="11" ry="8.5" fill="#f6dcb4" stroke="#5b3a1c" strokeWidth="2" />
            {/* eyes */}
            <circle cx="19" cy="20.5" r="2.3" fill="#3b2411" />
            <circle cx="29" cy="20.5" r="2.3" fill="#3b2411" />
            <circle cx="19.8" cy="19.7" r="0.8" fill="#fff" />
            <circle cx="29.8" cy="19.7" r="0.8" fill="#fff" />
            {/* nose + smile */}
            <circle cx="21.6" cy="28" r="1.1" fill="#8a5a2b" />
            <circle cx="26.4" cy="28" r="1.1" fill="#8a5a2b" />
            <path d="M19.5 31.5 C 22 34.5 26 34.5 28.5 31.5" fill="none" stroke="#8a5a2b" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}
